var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing.unconnected",
    transform: "translate(-1179.000000, -829.000000)",
    fill: "#8B93A7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(395.000000, 578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(470.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general/menu-dot",
    transform: "translate(314.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,6.16666667 C8.92047458,6.16666667 9.66666667,6.91285875 9.66666667,7.83333333 C9.66666667,8.75380792 8.92047458,9.5 8,9.5 C7.07952542,9.5 6.33333333,8.75380792 6.33333333,7.83333333 C6.33333333,6.91285875 7.07952542,6.16666667 8,6.16666667 Z M8,0.333333333 C8.92047458,0.333333333 9.66666667,1.07952542 9.66666667,2 C9.66666667,2.92047458 8.92047458,3.66666667 8,3.66666667 C7.07952542,3.66666667 6.33333333,2.92047458 6.33333333,2 C6.33333333,1.07952542 7.07952542,0.333333333 8,0.333333333 Z M8,-5.5 C8.92047458,-5.5 9.66666667,-4.75380792 9.66666667,-3.83333333 C9.66666667,-2.91285875 8.92047458,-2.16666667 8,-2.16666667 C7.07952542,-2.16666667 6.33333333,-2.91285875 6.33333333,-3.83333333 C6.33333333,-4.75380792 7.07952542,-5.5 8,-5.5 Z",
    id: "Combined-Shape",
    transform: "translate(8.000000, 2.000000) rotate(90.000000) translate(-8.000000, -2.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDot);
export default __webpack_public_path__ + "static/media/menu-dot.bf8e635745d95fb2f1cebd3daab37108.svg";
export { ForwardRef as ReactComponent };